export type MonthZeroBased = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11;

export function assertIsMonthZeroBased(val: number): asserts val is MonthZeroBased {
    if (val < 0 || val > 11) {
        throw new Error(`Provided value ${val} does not appear to be a valid MonthZeroBased`);
    }
}
